/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Callback_ErrorInputs */

const en_common_auth_callback_error = /** @type {(inputs: Common_Auth_Callback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not complete sign-in. Please try again.`)
};

const zh_common_auth_callback_error = /** @type {(inputs: Common_Auth_Callback_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录未能完成，请重试。`)
};

/**
* | output |
* | --- |
* | "Could not complete sign-in. Please try again." |
*
* @param {Common_Auth_Callback_ErrorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_callback_error = /** @type {((inputs?: Common_Auth_Callback_ErrorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Callback_ErrorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_callback_error(inputs)
	return zh_common_auth_callback_error(inputs)
});
export { common_auth_callback_error as "common.auth_callback.error" }